import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';

/**
 * A Pager just implements a paging control, with a page number, 
 * first, previous, next and last control elements.
 */
export class Pager extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = DojoTemplates(`Pager`);
		this.attachShadow({mode:`open`});
		this.shadowRoot.appendChild(this.el);
		Eventify(this.shadowRoot, this);
	}
	connectedCallback() {

	}

	enable(el, enable=true) {
		if (enable) {
			el.removeAttribute('disabled');
		} else {
			el.setAttribute('disabled','disabled');
		}
	}
	first(evt) {
		this.gotoPage(evt, 0);
	}
	previous(evt) {
		this.gotoPage(evt, this.page - 1);
	}
	next(evt) {
		this.gotoPage(evt, this.page + 1);
	}
	last(evt) {
		this.gotoPage(evt, this.pageCount-1);
	}
	enterPageCallback(evt) {
		this.gotoPage(evt, parseInt(this.$.page.value)-1);
	}
	gotoPage(evt, page) {
		evt.stopPropagation();

		if (
			(page==this.page) || (0>page) || (page>=this.pageCount)
			) return;

		this.dispatchEvent(new CustomEvent(`pager-goto`, 
		{
			composed: true,
			bubbles: false,
			detail: page 
		}));
	}
	setControls() {
		let page = this.page;
		let pageCount = this.pageCount;
		this.enable(this.$.first, 0<page);
		this.enable(this.$.previous, 0<page);
		this.enable(this.$.last, pageCount-1>page);
		this.enable(this.$.next, pageCount-1>page);
		this.$.page.setAttribute(`max`, pageCount);
	}
	get page() {
		return parseInt(this.getAttribute(`page`));
	}
	get pageCount() {
		return parseInt(this.getAttribute(`page-count`));
	}
	static get observedAttributes() {
		return ['page','page-count','record-count'];
	}
	attributeChangedCallback(attr, oldValue, newValue) {
		if (newValue==oldValue) return;
		switch (attr) {
		case `page`:
			this.$.page.value = parseInt(newValue)+1;
			this.setControls();
			break;
		case `page-count`:
			this.$.pageCount.innerText = newValue;
			this.setControls();
			break;
		case `record-count`:
			this.$.recordCount.innerText = newValue;
			break;
		}
	}
}

customElements.define(`dojo-pager`,Pager);